import axios from 'axios'
import qs from 'qs'
import {getStore, setStore} from "../utils/storage";
import md5 from 'js-md5';
import {signStr} from '../utils/signFn'

axios.defaults.timeout = 30000;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'
// axios.defaults.withCredentials = true;
export default {
  fetchGet(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, {headers:{
        'token':getStore('token') || '',
          'deviceType':'H5',
          'ts':Date.parse(new Date()),
          'sign':md5(signStr())
        },params}).then(res => {
        // console.log('请求连接：',url);
        // console.log(res.data);
        // debugger
        if (res.data.code === 501) {
          setStore('token', '');
          // window.location.reload();
        }else{
        }
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPost(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'token': getStore('token') || '',
          'deviceType':'H5',
          'ts':Date.parse(new Date()),
          'sign':md5(signStr())
        }
      }).then(res => {
        if (res.data.code === 501) {
          setStore('token', '');
          // window.location.reload();
        }else{
        }
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPostJSON(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, JSON.stringify(params), {
        headers: {
          'Content-Type': 'application/json',
          'token': getStore('token') || '',
          'deviceType':'H5',
          'ts':Date.parse(new Date()),
          'sign':md5(signStr())
        }
      }).then(res => {
        if (res.data.code === 501) {
          setStore('token', '');
          // window.location.reload();
        }else{
        }
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 该上传图片的接口弃用
  uploadFile(url, formData) {
    return new Promise((resolve, reject) => {
      // axios.post(url, {upfile:formData}, {
      axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': getStore('token') || '',
          'deviceType':'H5',
          'ts':Date.parse(new Date()),
          'sign':md5(signStr())
        }
      }).then(res => {
        if (res.data.code === 501) {
          setStore('token', '');
          // window.location.reload();
        }else{
        }
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }


}



// WEBPACK FOOTER //
// ./src/api/utils.js